import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./style.css";
import AppBar from "material-ui/AppBar";
import Drawer from "material-ui/Drawer";
import Divider from "material-ui/Divider";
import MenuItem from "material-ui/MenuItem";
import IconMenu from "material-ui/IconMenu";
import IconButton from "material-ui/IconButton";
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert";
import RaisedButton from "material-ui/RaisedButton";
import { AppArea } from "components/Utils";
import { PrimaryButton, FacebookButton } from "components/ui/Buttons";
import noop from "lodash/noop";
import classnames from "classnames";

const rootstyles = {
  button: { margin: "5px 0 0 10px" },
};

const Button = ({ style, ...otherProps }) => {
  const styleMerge = { ...rootstyles.button, ...style };
  return <RaisedButton style={styleMerge} {...otherProps} />;
};

const Menu = ({ children }) => {
  return (
    <IconMenu
      iconButtonElement={
        <IconButton>
          <MoreVertIcon />
        </IconButton>
      }
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      targetOrigin={{ horizontal: "right", vertical: "bottom" }}>
      {children}
    </IconMenu>
  );
};

class component extends Component {
  state = { isMenuOpen: false };

  toggleVisibility = () => this.setState({ isMenuOpen: !this.state.isMenuOpen });

  render() {
    const { isMenuOpen } = this.state;
    const { className } = this.props;

    return (
      <div className={classnames("App-menu-and-frame", className)}>
        <AppBar
          title={this.props.title}
          onLeftIconButtonClick={this.toggleVisibility.bind(this)}
          iconElementRight={this.props.renderButtonBar({ Button, PrimaryButton, FacebookButton, Menu, MenuItem })}
        />
        <Drawer docked={false} open={this.state.isMenuOpen} onRequestChange={this.toggleVisibility.bind(this)}>
          <MenuItem primaryText="Home" onClick={this.props.onNavigate.bind(this, "/")} />
          <Divider />
          {this.props.isLoggedIn ? <MenuItem primaryText="Build" className="App-menu-highlight" onClick={this.props.onNavigate.bind(this, "/build")} /> : null}
          {this.props.hasSubscription ? <MenuItem primaryText="My Saves / PDF Converter" onClick={this.props.onNavigate.bind(this, "/my-saves")} /> : null}
          <MenuItem primaryText="How To" onClick={this.props.onNavigate.bind(this, "/howto")} />
          <MenuItem primaryText="Store" onClick={this.props.onNavigate.bind(this, "/shop")} />
          <MenuItem primaryText="News" onClick={this.props.onNavigate.bind(this, "/news")} />
          <MenuItem primaryText="Community" onClick={this.props.onNavigate.bind(this, "/community")} />
          <MenuItem primaryText="Privacy Policy" onClick={this.props.onNavigate.bind(this, "/privacy")} />
          <Divider />
          {this.props.isLoggedIn ? <MenuItem primaryText="Logout" onClick={this.props.onNavigate.bind(this, "/logout")} /> : null}
        </Drawer>
        <AppArea scroll={this.props.scroll} className="App__content">
          {this.props.children}
        </AppArea>
        <div className="App__footer">copyright &copy; 2007-{new Date().getFullYear()} Pocketmod / Variant, LLC.</div>
      </div>
    );
  }
}

component.propTypes = {
  onNavigate: PropTypes.func,
  renderButtonBar: PropTypes.func,
  title: PropTypes.string,
  scroll: PropTypes.bool,
};

component.defaultProps = {
  onNavigate: noop,
  renderButtonBar: noop,
  title: "",
  scroll: false,
};

export default component;



// WEBPACK FOOTER //
// ./src/views/AppMenuAndFrame/component.js